import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {Outsourced} from "../Outsourced";
import {OutsourcedGameAssets} from "../OutsourcedGameAssets";
import {gsap} from "gsap";
import {BasedCountUp} from "./BasedCountUp";
import {GSAPUtils} from "../utils/GSAPUtils";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {OutsourcedCrashGameWinPresentation} from "../gameflow/OutsourcedCrashGameWinPresentation";
import {OutsourcedCrashGameIdlePresentation} from "../gameflow/OutsourcedCrashGameIdlePresentation";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/component/BitmapCountUp";
import {BrickSnake2000ReelSet} from "../server/BrickSnake2000ReelSet";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {OutsourcedSound} from "../sound/OutsourcedSound";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";

export class UpgradeBet extends PIXI.Container {

    yesButton:ContinueButton;
    noButton:ContinueButton;
    yesButtonCallback:Function;
    noButtonCallback:Function;
    promptBox:PIXI.Sprite;
    text:PIXI.Text;
    controller:FlowStateController;
    rtpSticker:PIXI.Sprite;
    replayClick:TimelineSprite;

    constructor() {
        super();

        const translations = Outsourced.apiPlugin.translations;
        const assetLoader = Outsourced.assetLoader;

        this.yesButton = new ContinueButton(translations.translate("YES"));
        this.yesButton.setSize(240, 120);
        this.yesButtonCallback = this.clickedYes;
        this.yesButton.addClickCallback(() => this.yesButtonCallback());
        this.yesButton.position.set(210, 560);
        this.yesButton.pivot.set(this.yesButton.width * 0.5, this.yesButton.height * 0.5);
        this.yesButton.enable(false);
        this.yesButton.alpha = 0;

        this.noButton = new ContinueButton(translations.translate("NO"));
        this.noButton.setSize(240, 120);
        this.noButtonCallback = this.clickedNo;
        this.noButton.addClickCallback(() => this.noButtonCallback());
        this.noButton.position.set(510, 560);
        this.noButton.pivot.set(this.noButton.width * 0.5, this.noButton.height * 0.5);
        this.noButton.enable(false);
        this.noButton.alpha = 0;

        this.promptBox = new PIXI.Sprite(assetLoader.getTextures("Info_Window")[0]);
        this.promptBox.position.set(360, 360);
        this.promptBox.anchor.set(0.5, 0.5);

        const rtp = Outsourced.model.initData.featureBuyTimesBetValue[7] && Outsourced.model.initData.featureBuyTimesBetValue[7].name === "EXTRA_SPIN" ? Outsourced.model.initData.featureBuyTimesBetValue[7].price : 96;
        this.rtpSticker = new PIXI.Sprite(assetLoader.getTextures(`RTP_Stickers/RTP_${rtp}`)[0]);
        this.rtpSticker.position.set(530, 130)
        this.rtpSticker.anchor.set(0.5, 0.5);
        this.rtpSticker.visible = Outsourced.model.initData.featureBuyTimesBetValue[7] && Outsourced.model.initData.featureBuyTimesBetValue[7].name === "EXTRA_SPIN";

        const upgradeBetCost = Outsourced.model.data.upgradeBetCost;
        const textStyle = new PIXI.TextStyle({
            fill: "#00FF66",
            fontFamily: "Helvetica",
            fontSize: 50,
            fontStyle: "oblique",
            fontWeight: "bolder",
            lineJoin: "round",
            strokeThickness: 8,
            wordWrapWidth: 600,
            wordWrap: true,
            breakWords: true,
        });
        this.text = new PIXI.Text(translations.translate("Buy Extra Spin For 80 (deducted from your win)?").replace("80", Outsourced.apiPlugin.currency.format(upgradeBetCost)), textStyle);
        this.text.position.set(360, 360);
        this.text.anchor.set(0.5, 0.5);

        this.alpha = 0;

        this.replayClick = new TimelineSprite(Outsourced.assetLoader.getTextures(OutsourcedGameAssets.REPLAY_CLICK));
        this.replayClick.blendMode = PIXI.BLEND_MODES.ADD;
        this.replayClick.scale.set(2,2);
        this.replayClick.anchor.set(0.5, 0.5);
        this.replayClick.position.set(360, 560);
        this.replayClick.hide();

        this.addChild(this.promptBox);
        this.addChild(this.text);
        if (Outsourced.apiPlugin.gameClientConfiguration.hideRtp != true)
            this.addChild(this.rtpSticker)
        this.addChild(this.noButton);
        this.addChild(this.yesButton);
        this.addChild(this.replayClick);
    }

    enable(controller:FlowStateController):gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                Outsourced.soundPlayer.playSoundBased("extraSpinPopUp");
                this.controller = controller;
                this.promptBox.visible = true;
                this.text.visible = true;
                this.yesButton.enable(true);
                this.noButton.enable(true);
                const upgradeBetCost = Outsourced.model.data.upgradeBetCost;
                const translatedString = Outsourced.apiPlugin.translations.translate("Buy Extra Spin For 80 (deducted from your win)?").replace("80", Outsourced.apiPlugin.currency.format(upgradeBetCost))
                this.text.text = translatedString
            })
            .add(gsap.to(this, {duration: 0.2, alpha: 1}), '<')
            .add(gsap.to(this.noButton, {duration: 0.2, alpha: 1}), '<')
            .add(gsap.to(this.yesButton, {duration: 0.2, alpha: 1}), '<')
    }

    clickedYes():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.noButton.enable(false);
                this.yesButton.enable(false);
                Outsourced.apiPlugin.betHandler.zeroBet({playUpgradeBet:1})
                const newWinAmount = Outsourced.model.data.accumulatedRoundWin - Outsourced.model.data.upgradeBetCost;
                Outsourced.keypadPlugin.setWin(newWinAmount, true, Outsourced.isWinBelowStake());
                Outsourced.soundPlayer.playSound(OutsourcedSound.CONTINUE_BUTTON);
                this.controller.finish();
            })
            .add(gsap.to(this, {duration: 0.2, alpha: 0}), '<')
            .add(gsap.to(this.noButton, {duration: 0.2, alpha: 0}), '<')
            .add(gsap.to(this.yesButton, {duration: 0.2, alpha: 0}), '<')
    }

    clickedNo():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.noButton.enable(false);
                this.yesButton.enable(false);
                Outsourced.apiPlugin.betHandler.zeroBet({playUpgradeBet:0})
                Outsourced.soundPlayer.playSound(OutsourcedSound.CONTINUE_BUTTON);
                this.controller.finish();
            })
            .add(gsap.to(this, {duration: 0.2, alpha: 0}), '<')
            .add(gsap.to(this.noButton, {duration: 0.2, alpha: 0}), '<')
            .add(gsap.to(this.yesButton, {duration: 0.2, alpha: 0}), '<')
    }

    replay(controller:FlowStateController):gsap.core.Timeline {
        const option = Outsourced.model.data.nextPlayerInteraction.playUpgradeBet != undefined
                       ? parseInt(Outsourced.model.data.nextPlayerInteraction.playUpgradeBet, 10)
                       : 0;
        return gsap.timeline()
            .add(() => {
                Outsourced.soundPlayer.playSoundBased("extraSpinPopUp");
                this.controller = controller;
                this.promptBox.visible = true;
                this.text.visible = true;
                this.yesButton.enable(false);
                this.noButton.enable(false);
                const upgradeBetCost = Outsourced.model.data.upgradeBetCost;
                const translatedString = Outsourced.apiPlugin.translations.translate("Buy Extra Spin For 80 (deducted from your win)?").replace("80", Outsourced.apiPlugin.currency.format(upgradeBetCost))
                this.text.text = translatedString
            })
            .add(gsap.to(this, {duration: 0.2, alpha: 1}), '<')
            .add(gsap.to(this.noButton, {duration: 0.2, alpha: 1}), '<')
            .add(gsap.to(this.yesButton, {duration: 0.2, alpha: 1}), '<')
            .add(() => {
                this.replayClick.position.x = option == 0 ? 510 : 210;
                this.replayClick.show();
                this.replayClick.playLoop();
                Outsourced.soundPlayer.playSound(OutsourcedSound.CONTINUE_BUTTON);
            }, '>1')
            .add(() => {
                this.replayClick.hide();
                this.replayClick.stopLoop();
                this.replayClick.setFrame(0);
                Outsourced.apiPlugin.betHandler.zeroBet({playUpgradeBet:option});
                if (option == 1) {
                    const newWinAmount = Outsourced.model.data.accumulatedRoundWin - Outsourced.model.data.upgradeBetCost;
                    Outsourced.keypadPlugin.setWin(newWinAmount, true, Outsourced.isWinBelowStake());
                }
                controller.finish();
            }, `>${this.replayClick.totalDuration}`)
            .add(gsap.to(this, {duration: 0.2, alpha: 0}), '<')
            .add(gsap.to(this.noButton, {duration: 0.2, alpha: 0}), '<')
            .add(gsap.to(this.yesButton, {duration: 0.2, alpha: 0}), '<')
    }
}